import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import IconAddPerson from "../../components/icons/IconAddPerson";
import * as api from "./api";

// Some legacy rows store "null"/"undefined" as a literal string (sometimes
// with stray whitespace) instead of a real null - filter those out too.
function clean(value) {
    if (!value) return "";
    const trimmed = String(value).trim();
    const lower = trimmed.toLowerCase();
    return lower && lower !== "null" && lower !== "undefined" ? trimmed : "";
}

export default function AssignUserButton({ conversation }) {
    const [isOpen, setIsOpen] = useState(false);
    const [people, setPeople] = useState([]);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");

    useEffect(() => {
        if (!isOpen) return;
        axios.get("/api/students", { withCredentials: true }).then((response) => {
            const students = (response.data || [])
                .filter((student) => student.addedOuterUser)
                .map((student) => ({
                    id: student.id,
                    type: "student",
                    name: (clean(student.name) + " " + clean(student.surname)).trim() || "Студент #" + student.id,
                }));
            setPeople((prev) => mergeUnique(prev, students));
        }).catch((err) => console.error(err));

        axios.get("/api/clients", { withCredentials: true }).then((response) => {
            const clients = (response.data || [])
                .filter((client) => client.addedOuterUser)
                .map((client) => ({
                    id: client.id,
                    type: "client",
                    name: (clean(client.firstName) + " " + clean(client.lastName)).trim() || "Клієнт #" + client.id,
                }));
            setPeople((prev) => mergeUnique(prev, clients));
        }).catch((err) => console.error(err));
    }, [isOpen]);

    const mergeUnique = (prev, added) => {
        const key = (p) => p.type + "-" + p.id;
        const existingKeys = new Set(prev.map(key));
        return [...prev, ...added.filter((p) => !existingKeys.has(key(p)))];
    };

    const visiblePeople = useMemo(() => {
        const term = search.trim().toLowerCase();
        const filtered = term ? people.filter((p) => p.name.toLowerCase().includes(term)) : people;
        return filtered.slice(0, 30);
    }, [people, search]);

    const assign = (person) => {
        setStatus("saving");
        api.assignConversationToUser(conversation.id, {
            studentId: person.type === "student" ? person.id : null,
            clientId: person.type === "client" ? person.id : null,
        })
            .then(() => setStatus("done"))
            .catch((err) => {
                console.error(err);
                setStatus("error");
            });
    };

    return (
        <div className="functional-panelbutton toolbar-popup-anchor" onClick={() => setIsOpen((prev) => !prev)}>
            <IconAddPerson fillColor="icon-blue" style={{ height: 20, width: 20 }} />

            {isOpen ? (
                <div className="toolbar-popup" style={{ width: 300 }} onClick={(e) => e.stopPropagation()}>
                    <p className="toolbar-popup-title">Призначити тест</p>

                    {status === "done" ? <p className="toolbar-popup-subtitle">Призначено ✓</p> : ""}
                    {status === "error" ? <p className="toolbar-popup-error">Не вдалося призначити</p> : ""}

                    <input
                        className="toolbar-popup-search"
                        placeholder="Пошук учня/клієнта..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <ul className="toolbar-popup-list toolbar-popup-list-clickable">
                        {visiblePeople.map((person) => (
                            <li key={person.type + "-" + person.id} onClick={() => assign(person)}>
                                <span>{person.name}</span>
                                <span className="toolbar-popup-badge">{person.type === "client" ? "Клієнт" : "Студент"}</span>
                            </li>
                        ))}
                        {visiblePeople.length === 0 ? <li>Нікого не знайдено</li> : ""}
                    </ul>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
